import '../profileSteps.scss';
import 'sass/blocks/_signing.scss';
import 'commonsComponents/_OKCheckbox.scss';

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as formActions } from 'react-redux-form';
import cryptoJS from 'crypto-js';
import { ORIGIN_BY_CHANNEL } from 'constants/uTagConstants/origin';
import { history } from 'routes/history';
import { FormattedText, formatText } from 'core/i18n';
import UtagHelper from 'utilities/utagHelper';
import { ALLOW_COOKIE } from 'constants';
import { LOGALTY_IMPLEMENTATION } from 'constants/steps';
import { BASE_PATH } from 'constants/index';
import FeatureTogglingRender from 'components/featureToggling/featureTogglingRender';
import { ONB_BANK_ACCOUNT_OPEN_PROMO } from 'constants/onboardingTypes';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import LogaltyError from './LogaltyError/LogaltyError';
import { getStepsTextsByImplementation } from 'utilities/getStepsTextsByImplementation';
import LogaltyIframe from './LogaltyIframe/LogaltyIframe';
import { getIsOwner } from 'utilities/jointHolders/holderTypes';
import optionsActions from 'actions/optionsActions';
import initialActions from 'actions/initialActions';
import promotionalCodeAction from 'actions/promotionalCodeAction';
import signActions from 'actions/signActions';
import preLoaderActions from 'actions/preLoaderActions';
import consentsActions from 'actions/consentsActions';
import HighLightedText from 'components/highLightedText/highLightedText';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import Storage from 'utilities/storage';
import { Modal } from 'react-bootstrap';
import { clickTaleEnd } from 'utilities/clickTale';
import {
    recordEvent,
    recordEventGdpr,
    RELIABLE,
    PAGE_PRODUCT,
    errorTag,
    recordRAPage,
    recordEventStepSuccess,
} from 'utilities/uTagging';
import { PATH_CONTRACT, LOGALTY_CONTRACT_START_PATH, LOGALTY_CONTRACT_PATH } from 'constants/uTagConstants/paths';
import { GDPR_DRF } from 'constants/featureFlagging';
import { LOGALTY_EVENT_CODES } from 'constants/logalty';
import { ERROR_AL_ENVIAR_CONTENIDO_GDPR, ERROR_AL_CREAR_EL_CONTRATO } from 'constants/analyticsErrors';
import { PRODUCT_NAME_ROBO, INVEST_PROFILE } from 'constants/uTagConstants/RAConstants';
import { ROBO, GBI, CREDIT_CARD } from 'constants/userProfile';
import { goToErrorsView, recordAndSavePage } from 'actions/errorViewNavigation';
import { OKConsents } from 'gdpr-consents/components/OKConsents/OKConsents';
import { getGA4EventKeys } from 'utilities/ga4';

class ProfileStep4 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showServerError: false,
            blowupClass: 'blowup-modal blowup-in',
            showIframe: false,
            errorCode: null,
            logaltyUrl: null,
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleCreateContract = this.handleCreateContract.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
        (this.handleHideModal = this.handleHideModal.bind(this)), (this.buildModalKO = this.buildModalKO.bind(this));
        this.handleBlowupClass = this.handleBlowupClass.bind(this);
        this.onGdprAcceptAll = this.onGdprAcceptAll.bind(this);
        this.onGdprChangeValue = this.onGdprChangeValue.bind(this);
        this.onGdprDisclaimerLinkClick = this.onGdprDisclaimerLinkClick.bind(this);
        this.listenForIframeEvents = this.listenForIframeEvents.bind(this);
        this.handleLogaltyErrorClick = this.handleLogaltyErrorClick.bind(this);
        this.recordLogaltyPage = this.recordLogaltyPage.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sign.get('implementation') !== this.props.sign.get('implementation')) {
            this.recordLogaltyPage();
            if (this.props.sign.get('implementation') === LOGALTY_IMPLEMENTATION) {
                window.addEventListener('message', this.listenForIframeEvents, false);
            } else {
                window.removeEventListener('message', this.listenForIframeEvents);
            }
        }
    }

    UNSAFE_componentWillMount() {
        const { userProfile } = this.props;

        window.scrollTo(0, 0);

        if (userProfile.contract === 'exception') {
            this.handleShowModal();
        }
    }

    recordLogaltyPage(isContractStarted = false) {
        const { userProfile, products, sign, recordAndSavePage } = this.props;

        const jointHolderInfo = UtagHelper.getJointHolderInfoFromUserProfile(userProfile);

        const path = isContractStarted ? LOGALTY_CONTRACT_START_PATH : LOGALTY_CONTRACT_PATH;

        if (userProfile.investmentType !== ROBO) {
            recordAndSavePage(
                path,
                userProfile.recordId,
                userProfile.userId,
                userProfile.product,
                products.get('productsDescription'),
                userProfile.promoCode ? userProfile.promoCode : '',
                jointHolderInfo,
                '',
                '',
                userProfile.investmentType,

                {
                    ...getGA4EventKeys({
                        eventName: isContractStarted ? 'step_contract_start' : 'step_contract',
                        pageName: path,
                        processDetail: isContractStarted ? 'start' : 'contract',
                        onboardingType: userProfile.investmentType,
                    }),
                    processStep: isContractStarted ? 'contract' : 'step7',
                    onboardingContractingProvider: sign.get('implementation'),
                }
            );
        }
    }

    componentDidMount() {
        const { userProfile } = this.props;
        const { investmentType } = userProfile;
        const { immCustomPlanByObjective, immManagementPlan, immSimulation, products } = this.props;

        if (investmentType === ROBO || investmentType === GBI) {
            let investProfile;
            let objective;

            switch (investmentType) {
                case ROBO:
                    investProfile =
                        INVEST_PROFILE[immManagementPlan.get('investProfileValue')] ||
                        immSimulation.get('selectedPortfolio') ||
                        '';
                    objective = '';
                    break;
                case GBI:
                    investProfile = INVEST_PROFILE[immCustomPlanByObjective.get('selectedStrategy')] || '';
                    objective = immCustomPlanByObjective.get('objectiveType');
                    break;
                default:
                    investProfile = '';
                    objective = '';
                    break;
            }

            recordRAPage(
                PATH_CONTRACT,
                `${PRODUCT_NAME_ROBO} ${investProfile} ${objective}`,
                userProfile.recordId,
                userProfile.userId,
                userProfile.product,
                products.get('productsDescription'),
                userProfile.promoCode ? userProfile.promoCode : '',
                false,
                '',
                '',
                userProfile.investmentType,
                ORIGIN_BY_CHANNEL[userProfile.channel]
            );
        }
    }

    listenForIframeEvents(event) {
        if (event.data) {
            switch (event.data.status) {
                case LOGALTY_EVENT_CODES.SIGNING_SUCCESSFUL:
                    history.push(`${BASE_PATH}/steps/${this.props.sign.get('contractToken')}/?event=signing_complete`);
                    break;
                case LOGALTY_EVENT_CODES.GENERIC_ERROR:
                case LOGALTY_EVENT_CODES.PIN_KO:
                case LOGALTY_EVENT_CODES.SESSION_EXPIRED:
                    this.setState({ errorCode: event.data.status, showIframe: false });
                    break;
                default:
                    break;
            }
        }
    }

    componentWillUnmount() {
        clickTaleEnd();
    }

    getConsentsData(isLogalty) {
        const { gdprConsents } = this.props;
        const consents = gdprConsents.get('consents');
        const array = [];

        consents.forEach(cell => {
            const data = {
                id: cell.getIn(['consentCell', 'id']),
                status: cell.get('status'),
            };

            if (isLogalty && data.status === 'PENDING') {
                data.status = 'NOT_ACCEPTED';
            }

            array.push(data);
        });

        return {
            consents: array,
            newCustomer: gdprConsents.get('newCustomer'),
        };
    }

    recordGdprClause(data) {
        const { userProfile } = this.props;
        const ids = {
            '01': 'comunicaciones de Openbank',
            '02': 'comunicaciones de terceros',
        };

        const values = {
            ACCEPTED: 'aceptado',
            NOT_ACCEPTED: 'no aceptado',
            PENDING: 'no aceptado',
        };

        let text = null;

        if (!data.length) {
            text = `${ids['01']}: ${values['ACCEPTED']} - ${ids['02']}: ${values['ACCEPTED']}`;
        } else if (data.length === 2) {
            text = `${ids[data[0].id]}: ${values[data[0].status]} - ${ids[data[1].id]}: ${values[data[1].status]}`;
        } else if (data[0].id === '01') {
            text = `${ids[data[0].id]}: ${values[data[0].status]} - ${ids['02']}: ${values['ACCEPTED']}`;
        } else if (data[0].id === '02') {
            text = `${ids['01']}: ${values['ACCEPTED']} - ${ids[data[0].id]}: ${values[data[0].status]}`;
        }

        recordEventGdpr(
            PATH_CONTRACT,
            PAGE_PRODUCT,
            'resultados de la claúsula GDPR',
            text,
            userProfile.recordId,
            userProfile.investmentType
        );
    }

    handleClick() {
        const { userProfile, consentsActions, preLoaderActions, sign, goToErrorsView } = this.props;
        const isLogalty = sign.get('implementation') === LOGALTY_IMPLEMENTATION;
        const accessToken = userProfile.accessToken;
        const data = this.getConsentsData(isLogalty);
        const infoArray = [
            formatText('button-contractGenerating'),
            formatText('button-contractWait'),
            formatText('button-contractVerifyData'),
            formatText('button-contractWait'),
            formatText('button-contractWriting'),
            formatText('button-contractWait'),
            formatText('button-contractAuthenticating'),
            formatText('button-contractWait'),
        ];

        preLoaderActions.setInformationArray(infoArray);
        preLoaderActions.showPreLoader();

        if (data.consents.length > 0) {
            consentsActions.sendConsents(accessToken, data, (valid, error) => {
                if (valid) {
                    this.recordGdprClause(data.consents);
                    this.handleCreateContract(accessToken);
                } else {
                    errorTag(error.body, PATH_CONTRACT, ERROR_AL_ENVIAR_CONTENIDO_GDPR, error.statusCode);
                    goToErrorsView({ errorCode: error.statusCode, errorMessage: ERROR_AL_ENVIAR_CONTENIDO_GDPR });
                }
            });
        } else {
            this.recordGdprClause(data.consents);
            this.handleCreateContract(accessToken);
        }
    }

    handleCreateContract(accessToken) {
        const { userProfile, signActions, preLoaderActions, sign, goToErrorsView } = this.props;
        const { docNumber } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';
        const isLogalty = sign.get('implementation') === LOGALTY_IMPLEMENTATION;

        signActions.loadingContract();
        signActions.createContract(
            accessToken,
            (sessionExpired, serverError, error) => {
                if (error) {
                    errorTag(error.body, PATH_CONTRACT, ERROR_AL_CREAR_EL_CONTRATO, error.statusCode);
                    goToErrorsView({ errorCode: error.statusCode, errorMessage: ERROR_AL_CREAR_EL_CONTRATO });
                    preLoaderActions.hidePreLoader();
                }
                this.setState({ showServerError: serverError });
                if (!sessionExpired && !serverError && !error) {
                    if (ALLOW_COOKIE && Storage.cookies.get('accessToken')) {
                        Storage.cookies.remove('accessToken');
                    }
                    recordEvent(
                        PATH_CONTRACT,
                        PAGE_PRODUCT,
                        'firmar contrato',
                        'firmar contrato correcto',
                        userProfile.recordId,
                        userProfile.userId,
                        RELIABLE[userProfile.identityMethod],
                        userProfile.investmentType,
                        docNumberEncrypted
                    );

                    recordEventStepSuccess(userProfile.investmentType, '/onboarding/contrato/', 'firma de contrato', {
                        event_name: 'event_success',
                        action: 'success',
                        format: 'steps',
                        component: 'funnel',
                        element: 'contract',
                    });

                    const contractUrl = this.props.sign.get('contractUrl');

                    if (!contractUrl) {
                        this.setState({ errorCode: LOGALTY_EVENT_CODES.GENERIC_ERROR, showIframe: false });
                        preLoaderActions.hidePreLoader();

                        return;
                    }

                    if (isLogalty) {
                        this.setState({ showIframe: true, logaltyUrl: contractUrl });
                        window.scrollTo(0, 0);
                        preLoaderActions.hidePreLoader();
                        this.recordLogaltyPage(true);
                    } else {
                        window.location.href = contractUrl;
                    }
                }
            },
            isLogalty
        );
    }

    handleShowModal() {
        this.setState({ showModal: true });
    }

    handleBlowupClass() {
        this.setState({ blowupClass: 'blowup-modal blowup-out' });
        setTimeout(() => {
            this.handleHideModal();
        }, 200);
    }

    handleHideModal() {
        this.setState({ showModal: false });
    }

    recordGdprClauseInteraction(value, id = '03') {
        const ids = {
            '01': 'comunicaciones de Openbank',
            '02': 'comunicaciones de terceros',
            '03': 'todas finalidades',
        };

        const values = {
            ACCEPTED: 'aceptado',
            NOT_ACCEPTED: 'no aceptado',
            PENDING: 'pendiente',
        };

        const { userProfile } = this.props;
        recordEventGdpr(
            PATH_CONTRACT,
            PAGE_PRODUCT,
            ids[id],
            `resultado claúsula: ${values[value]}`,
            userProfile.recordId,
            userProfile.investmentType
        );
    }

    onGdprAcceptAll(value) {
        this.recordGdprClauseInteraction(value);
    }

    onGdprChangeValue(id, value) {
        this.recordGdprClauseInteraction(value, id);
    }

    onGdprDisclaimerLinkClick(event) {
        const { userProfile } = this.props;
        const linkElement = event.target;
        if (linkElement) {
            recordEventGdpr(
                PATH_CONTRACT,
                PAGE_PRODUCT,
                'interstitial GDPR',
                linkElement.getAttribute('data-title'),
                userProfile.recordId,
                userProfile.investmentType
            );
        }
    }

    buildModalKO() {
        const modalClass = `timeout-modal overwritten-modal ${this.state.blowupClass}`;

        return (
            <div>
                <Modal
                    {...this.props}
                    show={this.state.showModal}
                    onHide={this.handleBlowupClass}
                    dialogClassName={modalClass}
                    backdrop="static"
                    keyboard={false}
                    animation={false}
                >
                    <Modal.Body>
                        <h3 className="font-heading3">
                            {formatText('signingPage-ExceptionModalTitle', [this.props.userProfile.name])}
                        </h3>
                        <div className="icon-container expired-Message">
                            <p className="font-paragraph2">
                                {formatText('signingPage-ExceptionModaltext1')}
                                <br />
                                {formatText('signingPage-ExceptionModaltext2')}
                            </p>
                        </div>
                        <div className="form__buttons">
                            <button className="form__button form__button-secondary" onClick={this.handleBlowupClass}>
                                {formatText('button-accept')}
                            </button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    buildGdprTitle() {
        const { userProfile } = this.props;
        const name = userProfile.name;

        return (
            <div>
                <hr />
                <div className="signing__consent-title">
                    <FormattedText value="gdpr-interstitialTitle" injectedStrings={[name]} />
                </div>
                <span className="dash"></span>
            </div>
        );
    }

    handleLogaltyErrorClick() {
        this.setState({ errorCode: null, showIframe: false });
    }

    render() {
        const { userProfile, products, promoCode, gdprConsents, sign } = this.props;
        const promotion = promoCode.get('promotionalCode');
        const gdprStatus = gdprConsents.get('status');
        const gdprConsentsSize = gdprConsents.get('consents').size > 0;
        const gdprTitle = gdprStatus && gdprConsentsSize ? this.buildGdprTitle() : null;
        const isLogalty = sign.get('implementation') === LOGALTY_IMPLEMENTATION;
        const guid = sign.get('envelopeId');
        const implementation = this.props.sign.get('implementation');

        const stepTexts = getStepsTextsByImplementation(implementation);

        let listOfDocuments = products.get('productsDescriptionOpenCredit');
        let promoCodeBases = '';

        listOfDocuments = listOfDocuments.split('+').join('/');
        listOfDocuments = `${listOfDocuments}.`;

        const modalKO = this.buildModalKO();
        let highLightedStyle = 'hidden';

        if (userProfile.contract === 'idCheckFailed' || userProfile.contract === 'recipientauthenticationfailed') {
            highLightedStyle = 'row hight-ligth';
        }

        let serverError = 'hidden';
        if (this.state.showServerError) {
            serverError = 'row hight-ligth';
        }

        if (userProfile.onboardingType === ONB_BANK_ACCOUNT_OPEN_PROMO) {
            promoCodeBases = (
                <div>
                    <dt>{formatText('signingPage-basesDescription')}</dt>
                    <dd />
                </div>
            );
        }

        let subscriptionDescription =
            userProfile.isJointHolderAccount === true ||
            (getIsOwner(userProfile.jointHolderType) && userProfile.jointHolderDecision === 'true')
                ? formatText('signingPage-subscriptionDescriptionJointHolder')
                : formatText('signingPage-subscriptionDescription');
        let contractDescription = formatText('signingPage-contractDescription');
        let openbankDocuSign = <FormattedText value="signingPage-OpenbankDocuSign" />;
        const openbankLogalty = <FormattedText value="signingPage-openbankLogalty" />;
        let customerLoginDescription = formatText('signingPage-customerLoginDescription');
        let gdprLegal = formatText('signingPage-gdprLegalIndex1');
        let precontractual = (
            <dt>
                {formatText('signingPage-precontractualDescription')}: <span>{listOfDocuments}</span>
            </dt>
        );
        let brochureDescription = formatText('signingPage-brochureDescription');
        let contractTC = null;

        if (promotion.size && promotion.get('title').toLowerCase() === 'broker') {
            subscriptionDescription = formatText('signingPage-brokerSubscriptionDescription');
            contractDescription = formatText('signingPage-brokerContractDescription');
            openbankDocuSign = formatText('signingPage-brokerOpenbankDocuSign');
            customerLoginDescription = formatText('signingPage-brokerCustomerLoginDescription');
        }

        if (userProfile.investmentType === CREDIT_CARD) {
            subscriptionDescription = formatText('signingPage-subscriptionDescriptionTC');
            gdprLegal = formatText('signingPage-gdprLegalIndex1TC');
            precontractual = <dt>{formatText('signingPage-precontractualDescriptionTC')}</dt>;
            contractDescription = formatText('signingPage-contractDescriptionTC');
            brochureDescription = formatText('signingPage-brochureDescriptionTC');
            contractTC = <dt>{formatText('signingPage-contractTC')}</dt>;
        }

        const columnWidth = isLogalty ? 'col-sm-6' : 'col-sm-4';

        return (
            <div>
                <ConditionalToggling condition={!this.state.showIframe && !this.state.errorCode}>
                    <div className="prospects-gutter prospects-separator">
                        <div className="signing-contract-view prospects-gutter" style={{ padding: 0 }}>
                            <div className="signing">
                                <div className="signing__blocks">
                                    <div className="signing__block">
                                        <h3 className="signing__what-sign">
                                            {formatText('contentStepsTitles-whatSign')}
                                        </h3>
                                        <div className="row">
                                            <div className="col-sm-12">
                                                {!isLogalty && <p>{subscriptionDescription}</p>}
                                                <dl>
                                                    <dd />

                                                    <FeatureTogglingRender notAllowedProductKey={GDPR_DRF}>
                                                        <dt>{formatText('signingPage-gdprDRF')}</dt>
                                                        <dd />
                                                    </FeatureTogglingRender>

                                                    <dt>{gdprLegal}</dt>
                                                    <dd />
                                                    {precontractual}
                                                    <dd />
                                                    {promoCodeBases}
                                                    <dt>{contractDescription}</dt>
                                                    <dd />
                                                    <dt>{brochureDescription}</dt>
                                                    <dd />
                                                    {contractTC}
                                                    <dd />
                                                </dl>
                                            </div>
                                        </div>
                                        <div className="signing__consent">
                                            {gdprTitle}
                                            <OKConsents
                                                placementId="interstitial"
                                                handleAcceptAll={this.onGdprAcceptAll}
                                                handleChangeValue={this.onGdprChangeValue}
                                                handleDisclaimerLinkClick={this.onGdprDisclaimerLinkClick}
                                                showChannels={false}
                                            />
                                        </div>
                                        <h5 className="signing__contract-holder">
                                            {isLogalty ? openbankLogalty : openbankDocuSign}
                                        </h5>
                                        {implementation !== null && (
                                            <div className="row">
                                                <div className="signing__contract-steps clearfix">
                                                    <div className={columnWidth}>
                                                        <div className="tutorial-box">
                                                            <div>
                                                                <i className="icons icons--icon-number-one"></i>
                                                            </div>
                                                            <div className="font-paragraph2">
                                                                <strong>{stepTexts.step1.title}</strong>
                                                            </div>
                                                        </div>
                                                        <p className="font-paragraph2 step-description">
                                                            {stepTexts.step1.description}
                                                        </p>
                                                    </div>
                                                    <div className={columnWidth}>
                                                        <div className="tutorial-box">
                                                            <div>
                                                                <i className="icons icons--icon-number-two"></i>
                                                            </div>
                                                            <div className="font-paragraph2">
                                                                <strong>{stepTexts.step2.title}</strong>
                                                            </div>
                                                        </div>
                                                        <p className="font-paragraph2 step-description">
                                                            {stepTexts.step2.description}
                                                        </p>
                                                    </div>
                                                    {!isLogalty && (
                                                        <div className="col-sm-4">
                                                            <div className="tutorial-box">
                                                                <div>
                                                                    <i className="icons icons--icon-number-three"></i>
                                                                </div>
                                                                <div className="font-paragraph2">
                                                                    <strong>
                                                                        {formatText('signingPage-customerLogin')}
                                                                    </strong>
                                                                </div>
                                                            </div>
                                                            <p className="font-paragraph2 step-description">
                                                                {customerLoginDescription}
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className={highLightedStyle}>
                                        <div className="col-sm-12">
                                            <HighLightedText
                                                className="form__hightlight-text form__hightlight-text--warning"
                                                icon={<i className="icons icons--icon-warning-red"></i>}
                                            >
                                                <FormattedText value="signingPage-warningText2" />
                                            </HighLightedText>
                                        </div>
                                    </div>
                                    <div className={serverError}>
                                        <div className="col-sm-12">
                                            <HighLightedText
                                                className="form__hightlight-text form__hightlight-text--warning"
                                                icon={<i className="icons icons--icon-warning-red"></i>}
                                            >
                                                <FormattedText value="signingPage-warningText3" />
                                            </HighLightedText>
                                        </div>
                                    </div>
                                    {modalKO}
                                </div>
                            </div>
                        </div>
                    </div>
                </ConditionalToggling>
                <ConditionalToggling condition={this.state.showIframe && !this.state.errorCode}>
                    <LogaltyIframe contractUrl={sign.get('contractUrl')} />
                </ConditionalToggling>
                <ConditionalToggling condition={!!this.state.errorCode}>
                    <LogaltyError errorCode={this.state.errorCode} onClick={this.handleLogaltyErrorClick} guid={guid} />
                </ConditionalToggling>
                <div className="form__footer">
                    <RoadmapNavigation
                        buttonFinalizeAndContinueHidden={this.state.showIframe || !!this.state.errorCode}
                        buttonFinalizeDisabled={!implementation}
                        buttonPrevHidden
                        buttonFinalizeHidden={false}
                        buttonContinueType="button"
                        buttonContinueAction={this.handleClick}
                        buttonFinalizeText={formatText('button-goToSign')}
                    />
                </div>
            </div>
        );
    }
}

module.exports.constructor = ProfileStep4;
module.exports.ProfileStep4 = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        immStepsState: state.steps,
        options: state.options,
        sign: state.sign,
        initialStep: state.initialStep,
        promoCode: state.promotionalCode,
        session: state.session,
        products: state.products,
        gdprConsents: state.gdprConsents,
        immManagementPlan: state.raManagementPlan,
        immSimulation: state.raSimulation,
        immCustomPlanByObjective: state.raCustomPlanByObjective,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
        signActions: bindActionCreators(signActions, dispatch),
        initialActions: bindActionCreators(initialActions, dispatch),
        promotionalCodeAction: bindActionCreators(promotionalCodeAction, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        consentsActions: bindActionCreators(consentsActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(ProfileStep4);
